module.exports = __webpack_public_path__ + "static/media/calendartime.9fe3089e.svg";